import { useEffect, useState } from "react";
import { Loader2, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { http, errMsg } from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleString(localStorage.getItem("ex_lang") === "en" ? "en-GB" : "id-ID", { dateStyle: "medium", timeStyle: "short" });

export default function HistoryLog({ properties = [], t }) {
  const [f, setF] = useState({ property_id: "", q: "" });
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const load = async (skip = 0) => {
    setBusy(true); setError("");
    try {
      const { data } = await http.get("/extranet/audit-logs", { params: { ...f, skip, limit: 50 } });
      setRows((r) => (skip ? [...r, ...data.items] : data.items)); setTotal(data.total);
    } catch (e) { setError(errMsg(e)); }
    setBusy(false);
  };
  useEffect(() => { const h = setTimeout(() => load(0), 300); return () => clearTimeout(h); }, [f.property_id, f.q]); // eslint-disable-line
  return (
    <div className="grid gap-4 p-5" data-testid="history-log">
      <p className="text-sm text-slate-600">{t("Catatan semua perubahan yang dibuat staf di extranet: siapa, kapan, properti dan apa yang diubah.")}</p>
      <div className="flex flex-wrap gap-2">
        <select data-testid="history-property" value={f.property_id} onChange={(e) => setF({ ...f, property_id: e.target.value })} className="h-10 rounded-md border border-slate-300 bg-white px-3 text-sm">
          <option value="">{t("Semua properti")}</option>
          {properties.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
        <div className="relative min-w-[220px] flex-1"><Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <Input data-testid="history-search" value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} placeholder={t("Cari email, aksi atau kode...")} className="pl-9" /></div>
      </div>
      {error && <p className="text-sm text-red-600" data-testid="history-error">{error}</p>}
      <div className="overflow-x-auto rounded-md border border-[#E7E0D6]">
        <table className="w-full min-w-[720px] text-sm" data-testid="history-table">
          <thead className="bg-[#F7F2EA] text-left text-xs uppercase text-slate-500">
            <tr><th className="p-2.5">{t("Waktu")}</th><th className="p-2.5">{t("Pengguna")}</th><th className="p-2.5">{t("Properti")}</th><th className="p-2.5">{t("Aksi")}</th><th className="p-2.5">{t("Detail")}</th></tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-[#EFE8DE]" data-testid={`history-row-${r.id}`}>
                <td className="whitespace-nowrap p-2.5 text-slate-500">{fmt(r.at)}</td>
                <td className="p-2.5"><span className="font-semibold">{r.staff_email}</span> <span className="text-xs text-slate-400">· {r.role}</span></td>
                <td className="p-2.5">{r.property_name || "—"}</td>
                <td className="p-2.5 font-semibold">{t(r.action)}</td>
                <td className="p-2.5 font-mono-x text-xs text-slate-500">{r.target || "—"}</td>
              </tr>
            ))}
            {!rows.length && !busy && <tr><td colSpan={5} className="p-6 text-center text-slate-400">{t("Belum ada riwayat")}</td></tr>}
          </tbody>
        </table>
      </div>
      <div className="flex items-center gap-3 text-sm text-slate-500">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />}
        <span data-testid="history-count">{rows.length} / {total}</span>
        {rows.length < total && <button data-testid="history-more" onClick={() => load(rows.length)} className="font-semibold text-[#B4693E]">{t("Muat lagi")}</button>}
      </div>
    </div>
  );
}
